import { Button, ButtonGroup } from '@chakra-ui/button'
import { Input } from '@chakra-ui/input'
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/modal'
import { useEffect, useState } from 'react'
import { Flex } from '@chakra-ui/layout'
import { Text } from '@chakra-ui/react'

export function InitialModalFilter({ isOpen, onClose, changeInputField, FiltrarStatus, state }) {
  const [loading, setLoading] = useState(false)
  const [loadingAll, setLoadingAll] = useState(false)

  async function mostrarTudo() {
    setLoadingAll(true)

    await FiltrarStatus()
    setLoadingAll(false)
    onClose()
  }

  async function filterNumped(e) {
    setLoading(true)

    changeInputField(e, 'input', 'pedido_selecionado')

    await FiltrarStatus()
    setLoading(false)
    onClose()
  }

  useEffect(() => {
    onClose()
  }, [state])

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Filtro inicial - Status Pedido</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex flexDir="column" gap={2}>
              <Text fontSize="lg" color="gray.500">
                Digite aqui o número do pedido para filtrar
              </Text>

              <Input type="text" placeholder="Digite o número do pedido" onChange={(e) => changeInputField(e, 'input', 'pedido_selecionado')} />
              <ButtonGroup>
                <Flex gap={4}>
                  <Button colorScheme="blue" isLoading={loading} onClick={(e) => filterNumped(e)}>
                    Buscar
                  </Button>
                  <Button onClick={(e) => mostrarTudo(e)} variant="outline" isLoading={loadingAll}>
                    Mostrar tudo
                  </Button>
                </Flex>
              </ButtonGroup>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}
